import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import NewsTicker from "@/pages/home/components/NewsTicker";
import LatestSection from "@/pages/home/components/LatestSection";
import HotRecommend from "@/pages/home/components/HotRecommend";
import BrandIntro from "@/pages/home/components/BrandIntro";

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />
      <NewsTicker />
      <CategoryQuickLinks />
      <LatestSection />
      <HotRecommend />
      <BrandIntro />
    </div>
  );
}